// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.infoContainerWrapper_EBiQ8 {
  display: flex;
  align-items: center;
  gap: 22px;
  padding: 0;
}


.infoContainer_YV1jR {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  padding: 0;

  div {
    color: #1f184b;
    font-size: 12px;
    font-weight: 500;
  }

  span {
    max-width: 360px;
    color: #1f184b;
    font-size: 12px;
    font-weight: 300;
  }
}

.infoContainerFile_i0WWQ {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0;
  padding: 0;
  margin: 0px;
  width: 100%;
}




.containerAgents_o9cvT {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  margin: 0;
}

.searchContainer_YUNGV {
  border: 1px solid var(--e0-border);
  border-radius: 5px;
  width: calc(100% - 20px);
  height: 40px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;


  svg {
    width: 20px;
    height: 20px;
  }

  input {
    background: transparent;
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    font-size: 15px;
    font-weight: 400;
  }

  .searchContainerShortcuts_SpUDl {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 22px;
    background: var(--ececf1-background);
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 3px;
  }
}

.noResultsContainer_Mr280 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;

  span {
    font-size: 12px;
    font-weight: 500;
  }

  p {
    font-size: 12px;
    font-weight: 300;
  }
}

.searchContainerList_LGQHx {
  padding: 0;
  margin: 0;
  list-style: none;
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;

}

.containerListAgents_FTf3I{
  padding: 0;
  margin: 0;
  list-style: none;
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
}

.agentItem_pezXL {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0px;
  width: 100%;
  border-bottom: 1px solid #eeeeee;

  &:hover {
    background: var(--f5-background);
  }

  .agentItemIcon_EFEmK {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    padding: 0;
    background: var(--_10a37f-background);
    border-radius: 50%;
    align-items: center;
    justify-content: center;
    width: 45px;
    min-width: 45px;
    height: 45px;

    svg {
      color: var(--white-background);
      width: 30px;
      height: 30px;
    }
  }

  .agentItemInfo_xW0rA {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 0px;
    padding: 0;
    margin: 0px;

    p {
      margin: 0px;
      font-size: 16px;
      font-weight: 500;
      color: #292828;
    }

    span {
      font-size: 16px;
      font-weight: 400;
      color: #7e7e7e;
    }
  }

  .agentItemActions_nM2r4 {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    gap: 0;
    padding: 0;
    margin-left: auto;

    .agentItemActionsInfo_wi9uq {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 4px;
      padding: 0;

      svg {
        width: 16px;
        height: 16px;
      }
    }

    .agentItemActionsItem_ke1ku {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 8px;
      padding: 0;
      align-items: flex-end;

      .agentItemActionsItemLabel_KqmnD {
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 0;
        font-size: 12px;
        font-weight: 300;
        background: #cccccc;
        color: #233f39;
        border-radius: 5px;
        padding: 0 4px;
        height: 20px;
        width: 20px;
        display: flex;

        svg {
          width: 12px;
          height: 12px;
          fill: #233f39;
        }
      }

      span {
        font-size: 12px;
        font-weight: 300;
      }
    }
  }
}

`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Automate/Components/TelamatelFormAutomate/CustomAgent/CustomAgent.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;;AAGA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,UAAU;;EAEV;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,MAAM;EACN,UAAU;EACV,WAAW;EACX,WAAW;AACb;;;;;AAKA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;;;EAGR;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,eAAe;IACf,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,MAAM;;EAEN;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,WAAW;;AAEb;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,gCAAgC;;EAEhC;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,MAAM;IACN,UAAU;IACV,qCAAqC;IACrC,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,eAAe;IACf,YAAY;;IAEZ;MACE,8BAA8B;MAC9B,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,QAAQ;IACR,UAAU;IACV,WAAW;;IAEX;MACE,WAAW;MACX,eAAe;MACf,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,eAAe;MACf,gBAAgB;MAChB,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,MAAM;IACN,UAAU;IACV,iBAAiB;;IAEjB;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,QAAQ;MACR,UAAU;;MAEV;QACE,WAAW;QACX,YAAY;MACd;IACF;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,sBAAsB;MACtB,QAAQ;MACR,UAAU;MACV,qBAAqB;;MAErB;QACE,mBAAmB;QACnB,uBAAuB;QACvB,QAAQ;QACR,UAAU;QACV,eAAe;QACf,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;QACd,kBAAkB;QAClB,cAAc;QACd,YAAY;QACZ,WAAW;QACX,aAAa;;QAEb;UACE,WAAW;UACX,YAAY;UACZ,aAAa;QACf;MACF;;MAEA;QACE,eAAe;QACf,gBAAgB;MAClB;IACF;EACF;AACF","sourcesContent":[".infoContainerWrapper {\n  display: flex;\n  align-items: center;\n  gap: 22px;\n  padding: 0;\n}\n\n\n.infoContainer {\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  padding: 0;\n\n  div {\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  span {\n    max-width: 360px;\n    color: #1f184b;\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.infoContainerFile {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0;\n  padding: 0;\n  margin: 0px;\n  width: 100%;\n}\n\n\n\n\n.containerAgents {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  padding: 0;\n  margin: 0;\n}\n\n.searchContainer {\n  border: 1px solid var(--e0-border);\n  border-radius: 5px;\n  width: calc(100% - 20px);\n  height: 40px;\n  padding: 0 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n\n\n  svg {\n    width: 20px;\n    height: 20px;\n  }\n\n  input {\n    background: transparent;\n    width: 100%;\n    height: 100%;\n    border: none;\n    outline: none;\n    font-size: 15px;\n    font-weight: 400;\n  }\n\n  .searchContainerShortcuts {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 22px;\n    height: 22px;\n    background: var(--ececf1-background);\n    cursor: pointer;\n    -webkit-user-select: none;\n    user-select: none;\n    border-radius: 3px;\n  }\n}\n\n.noResultsContainer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0;\n\n  span {\n    font-size: 12px;\n    font-weight: 500;\n  }\n\n  p {\n    font-size: 12px;\n    font-weight: 300;\n  }\n}\n\n.searchContainerList {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n\n}\n\n.containerListAgents{\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 10px;\n  width: 100%;\n}\n\n.agentItem {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0px;\n  width: 100%;\n  border-bottom: 1px solid #eeeeee;\n\n  &:hover {\n    background: var(--f5-background);\n  }\n\n  .agentItemIcon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 0;\n    padding: 0;\n    background: var(--_10a37f-background);\n    border-radius: 50%;\n    align-items: center;\n    justify-content: center;\n    width: 45px;\n    min-width: 45px;\n    height: 45px;\n\n    svg {\n      color: var(--white-background);\n      width: 30px;\n      height: 30px;\n    }\n  }\n\n  .agentItemInfo {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 0px;\n    padding: 0;\n    margin: 0px;\n\n    p {\n      margin: 0px;\n      font-size: 16px;\n      font-weight: 500;\n      color: #292828;\n    }\n\n    span {\n      font-size: 16px;\n      font-weight: 400;\n      color: #7e7e7e;\n    }\n  }\n\n  .agentItemActions {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n    gap: 0;\n    padding: 0;\n    margin-left: auto;\n\n    .agentItemActionsInfo {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      gap: 4px;\n      padding: 0;\n\n      svg {\n        width: 16px;\n        height: 16px;\n      }\n    }\n\n    .agentItemActionsItem {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      flex-direction: column;\n      gap: 8px;\n      padding: 0;\n      align-items: flex-end;\n\n      .agentItemActionsItemLabel {\n        align-items: center;\n        justify-content: center;\n        gap: 4px;\n        padding: 0;\n        font-size: 12px;\n        font-weight: 300;\n        background: #cccccc;\n        color: #233f39;\n        border-radius: 5px;\n        padding: 0 4px;\n        height: 20px;\n        width: 20px;\n        display: flex;\n\n        svg {\n          width: 12px;\n          height: 12px;\n          fill: #233f39;\n        }\n      }\n\n      span {\n        font-size: 12px;\n        font-weight: 300;\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoContainerWrapper": `infoContainerWrapper_EBiQ8`,
	"infoContainer": `infoContainer_YV1jR`,
	"infoContainerFile": `infoContainerFile_i0WWQ`,
	"containerAgents": `containerAgents_o9cvT`,
	"searchContainer": `searchContainer_YUNGV`,
	"searchContainerShortcuts": `searchContainerShortcuts_SpUDl`,
	"noResultsContainer": `noResultsContainer_Mr280`,
	"searchContainerList": `searchContainerList_LGQHx`,
	"containerListAgents": `containerListAgents_FTf3I`,
	"agentItem": `agentItem_pezXL`,
	"agentItemIcon": `agentItemIcon_EFEmK`,
	"agentItemInfo": `agentItemInfo_xW0rA`,
	"agentItemActions": `agentItemActions_nM2r4`,
	"agentItemActionsInfo": `agentItemActionsInfo_wi9uq`,
	"agentItemActionsItem": `agentItemActionsItem_ke1ku`,
	"agentItemActionsItemLabel": `agentItemActionsItemLabel_KqmnD`
};
export default ___CSS_LOADER_EXPORT___;
